import EventEmitter from "./EventEmitter.js"

export default class Sizes extends EventEmitter{

    constructor(){
        super()

        // Setup
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.isMobile = window.matchMedia("(max-width: 768px), (pointer: coarse)").matches
        this.pixelRatio = this.getPixelRatio()


        // Resize Event
        window.addEventListener("resize", () => {
            this.width = window.innerWidth
            this.height = window.innerHeight
            this.isMobile = window.matchMedia("(max-width: 768px), (pointer: coarse)").matches
            this.pixelRatio = this.getPixelRatio()


            this.trigger('resize')
        })
    }

    getPixelRatio() {
        const maxPixelRatio = 2
        return Math.min(window.devicePixelRatio, maxPixelRatio)
    }
}
